import { render, staticRenderFns } from "./SurplusReturnPartAdd.vue?vue&type=template&id=255f78e6"
import script from "./SurplusReturnPartAdd.vue?vue&type=script&lang=js"
export * from "./SurplusReturnPartAdd.vue?vue&type=script&lang=js"
import style0 from "./SurplusReturnPartAdd.vue?vue&type=style&index=0&id=255f78e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports